import { tenantEnvConfig } from './tenantEnvConfig'
import { REACT_APP_ENV } from '~constants/apiString'

const featureFlagsByTenantSlug = {
  // Default for other tenants
  default: {
    subscriptionFeature: false,
    bottom_bar_information: false,
    deep_link: false,
    skyscrapperBannerAds: false,
  },

  odv: {
    subscriptionFeature: true,
    firebaseFeature: true,
    gtmFeature: true,
    onesignal: true,
    cookielaw: true,
    invite_referrals: true,
    bottom_bar_information: true,
    deep_link: true,
    notify_player: true,
    payment_card_feature: true,
    coupon_feature: true,
    vertical_ribbon: true,
    ppvPaymentPaypalFeature: true,
    ppvPaymentStripFeature: true,
    ppvPaymentBootpayFeature: false,
    deviceOptionsFeature: true,
    tvodFeature: true,
    skyscrapperBannerAds: true,
    loginGoogle: true,
    loginfb: true,
    nameAccount: true,
    popoverSignup: true,
  },

  sctv: {
    subscriptionFeature: true,
    firebaseFeature: true,
    bottom_bar_information: true,
    deep_link: false,
    notify_player: false,
    payment_sms_feature: REACT_APP_ENV === 'STAG' ? true : false,
    payment_method_feature: true,
    vertical_ribbon: false,
    loginPhoneNumber: true,
    svodAppFeature: false,
    deviceOptionsFeature: false,
    tvodFeature: false,
    skyscrapperBannerAds: false,
    pgMomoFeature: true,
    loginGoogle: false,
    loginfb: true,
    nameAccount: false,
    popoverSignup: false,
  },
  projectw: {
    subscriptionFeature: false,
    bottom_bar_information: true,
    deep_link: false,
    notify_player: false,
    vertical_ribbon: false,
    ppvPaymentBootpayFeature: true,
    tvodFeature: true,
    skyscrapperBannerAds: false,
    loginGoogle: false,
    loginfb: true,
    nameAccount: false,
    popoverSignup: false,
  },
  escondido: {
    subscriptionFeature: true,
    bottom_bar_information: false,
    deep_link: true,
    notify_player: false,
    vertical_ribbon: false,
    payment_card_feature: true,
    ppvPaymentPaypalFeature: true,
    ppvPaymentStripFeature: true,
    ppvPaymentBootpayFeature: false,
    tvodFeature: true,
    skyscrapperBannerAds: false,
    loginGoogle: false,
    loginfb: false,
    detailOnHover: true,
    nameAccount: true,
    popoverSignup: true,
  },
}

export const tenantFeatureFlags =
  tenantEnvConfig.ui_theme in featureFlagsByTenantSlug
    ? featureFlagsByTenantSlug[tenantEnvConfig.ui_theme]
    : featureFlagsByTenantSlug['default']
